export interface IStoneCut {
  id:'Brilliant'|'Princess'|'Baguette',
  diameterToDepth:number
}

export const STONE_CUTS:IStoneCut[] = [
  {
    id: 'Brilliant',
    diameterToDepth: 0.6
  },
  {
    id: 'Princess',
    diameterToDepth: 0.73
  },
  {
    id: 'Baguette',
    diameterToDepth: 0.65
  },
]